<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
              <Button
                label="Nuevo"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                @click="openNew"
              />
               
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="Exportar"
              icon="pi pi-upload"
              class="p-button-help"
              @click="exportCSV($event)"
            />
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="data"
          v-model:selection="selectedData"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Depósitos"
          responsiveLayout="scroll"
        >
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0">Depósitos</h5>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>


          <Column
            field="name"
            header="Nombre"
            :sortable="true"
            headerStyle="width:40%; min-width:10rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Nombre</span>
              {{ slotProps.data.name }}
            </template>
        </Column>

        <Column
            field="description"
            header="Descripción"
            :sortable="true"
            headerStyle="width:40%; min-width:10rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Descripción</span>
              {{ slotProps.data.description }}
            </template>
        </Column>

          <Column headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="editItem(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteItem(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>

        <Dialog
          v-model:visible="itemDialog"
          :style="{ width: '450px' }"
          header="Depósitos"
          :modal="true"
          class="p-fluid"
        >
          <div class="field">
            <label for="name">Nombre </label>
            <InputText
              id="name"
              v-model.trim="item.name"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !item.name }"
            />
            <small class="p-invalid" v-if="submitted && !item.name"
              >Nombre es requerido.</small
            >
          </div>

          <div class="field">
            <label for="name">Descripción </label>
            <InputText
              id="description"
              v-model.trim="item.description"
              autofocus
              :class="{ 'p-invalid': submitted && !item.description }"
            />
            
          </div>
          

          <template #footer>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              label="Guardar"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveItem"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteItemDialog"
          :style="{ width: '450px' }"
          header="Confirmación"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item"
              >Eliminaras a <b>{{ item.name }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteItemDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteItem"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteDataDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item">Seguro?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDataDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedData"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import CrudService from "../services/crud.service";

export default {
  data() {
    return {
      routeName: null,
      data: [{id:null, name:'', description:''}],
      itemDialog: false,
      deleteItemDialog: false,
      deleteDataDialog: false,
      item: {id:null, name:'', description:''},
      selectedData: null,
      filters: {},
      submitted: false,
      validationErrors: null      
    };
  },
   
  created() {
    this.routeName = this.$route.name;
     
    this.initFilters();
  },
  mounted() {
     CrudService.getCRUD(this.routeName).then(
      (data) => (this.data = data)
    );    

  },
  methods: {    
    openNew() {
      this.item = {};
      this.submitted = false;
      this.itemDialog = true;
    },
    hideDialog() {
      this.itemDialog = false;
      this.submitted = false;
    },
    displayErrors(errors) {      
              for (let key in errors) {
                this.validationErrors.push({ "field": key, "message": errors[key] });
                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
    },
    saveItem() {
      this.submitted = true;
      if (this.item.name) {
        if (this.item.id) {          

          CrudService.updateCRUD(this.routeName, this.routeName, this.item).then(
            (response) => {

            this.validationErrors = [];
            if (response.status == 400) { 

              this.displayErrors(response.data);

            } else {
              this.$toast.add({
                severity: "success",
                summary: "Éxito!",
                detail: "Actualizado correctamente.",
                life: 3000,
              });
              this.data[this.findIndexById(this.item.id)] = this.item;
              console.log('this.data')
              console.log(this.data)
              this.itemDialog = false;
              this.item = {};
            }
          });
        } else {
          CrudService.createCRUD(this.routeName, this.routeName, this.item).then(
            (response) => {
              
            this.validationErrors = [];
            if (response.status == 400) { 

              this.displayErrors(response.data);
              
              } else {
                this.data.push(response.data);
                console.log('this.data')
                console.log(this.data)
                this.$toast.add({
                  severity: "success",
                  summary: "Éxito!",
                  detail: "Creado correctamente.",
                  life: 3000,
                });
                this.itemDialog = false;
                this.item = {};
              }
            }
          );
        }
      }
    },
    editItem(item) {
      this.item = { ...item };
      this.itemDialog = true;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItem() {
      CrudService.deleteCRUD(this.routeName, this.routeName, this.item.id).then(
        (response) => {
          //this.data.splice(this.findIndexById(data.data.id), 1);
          this.data = this.data.filter((item) => item.id != response.data);
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Éxito!",
            detail: "Eliminado correctamente.",
            life: 3000,
          });
        }
      );

      this.deleteItemDialog = false;
      this.item = {};
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteDataDialog = true;
    },
    deleteSelectedData() {
      this.data = this.data.filter(
        (val) => !this.selectedData.includes(val)
      );
      this.deleteDataDialog = false;
      this.selectedData = null;
      this.$toast.add({
        severity: "success",
        summary: "Éxito!",
        detail: "Eliminado correctamente.",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
